import styled from '@emotion/styled'
import {cssTheme} from '@vio/atlas/themes'

export const TitleBar = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${cssTheme.layout.spacing.s300};
`
